import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { StoreBadges } from '@/components/Landing/LandingKit';
import { BILLING, CLOSING_TRUST } from '@/constants/pricingContent';
import { PricingButton, PricingLink, PricingSection, PricingTitle, usePricing } from './PricingKit';

function PricingClosing() {
  const { c } = usePricing();
  return <PricingSection label="Start using Gab AI">
    <View style={{ alignItems: 'center', gap: 20 }}>
      <PricingTitle align="center">See where an idea can take you.</PricingTitle>
      <Text tag="p" style={{ color: c.muted, fontSize: 17, lineHeight: 28, maxWidth: 520, textAlign: 'center' }}>Try Gab AI free. When you are ready for more, Plus starts at ${BILLING.annualPerMonth} a month, billed annually.</Text>
      <View style={{ flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', gap: 24, marginTop: 8 }}><PricingButton label="Start free" /><PricingLink label="See what it can do" href="/about" /></View>
      <Text style={{ color: c.muted, fontSize: 12, lineHeight: 20, textAlign: 'center' }}>{CLOSING_TRUST.join(' · ')}</Text>
      <View style={{ width: '100%', marginTop: 28, paddingTop: 32, borderTopWidth: 1, borderTopColor: c.rule, alignItems: 'center', gap: 20 }}>
        <Text style={{ color: c.muted, fontSize: 13, lineHeight: 21, textAlign: 'center' }}>At your desk. On the go. Wherever ideas find you.</Text>
        <StoreBadges scale={0.85} centered />
      </View>
    </View>
  </PricingSection>;
}
export default React.memo(PricingClosing);
